class RevealOnScroll extends HTMLElement {
  connectedCallback() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      this.hiddenOnInit = false;
      this.classList.add("reveal-none");
      return;
    }

    const delay = this.hasAttribute("delay") ? Number(this.getAttribute("delay")) : 0;
    if (delay > 0) {
      this.style.transitionDelay = delay + "ms";
    }

    this.classList.add("reveal-ready");
    this._visible = false;

    if (!this._observer && "IntersectionObserver" in window) {
      this._observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.classList.add("reveal-visible");
              this._visible = true;
              this._observer.unobserve(this);
            }
          });
        },
        { threshold: 0.15, rootMargin: "0px 0px -40px 0px" },
      );
      this._observer.observe(this);
    } else {
      this.classList.add("reveal-visible");
    }
  }

  disconnectedCallback() {
    if (this._observer) {
      this._observer.disconnect();
      this._observer = null;
    }
  }
}

if (!customElements.get("reveal-on-scroll")) {
  customElements.define("reveal-on-scroll", RevealOnScroll);
}
